import { render, staticRenderFns } from "./ServiceMobile.vue?vue&type=template&id=db175eea&scoped=true&"
import script from "./ServiceMobile.vue?vue&type=script&lang=js&"
export * from "./ServiceMobile.vue?vue&type=script&lang=js&"
import style0 from "./ServiceMobile.vue?vue&type=style&index=0&id=db175eea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db175eea",
  null
  
)

export default component.exports